import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAdminAuth } from '@/hooks/useAdminAuth';

export default function Layout() {
  useAdminAuth();

  return (
    <div className="flex min-h-screen bg-admin-bg">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
